import { getQueryDefinition } from '@intelligence/services/common';
import { fetchIntelligenceUserInfoResponse } from '@intelligence/services/userInfo';

export interface IntelligencePagePermissionRule {
  /** operationLog 中记录的页面 ID，兼容数字和数字字符串配置。 */
  pages?: Array<number | string>;
  /** 用户黑名单：填写完整用户邮箱或企微 ID。 */
  userExclude?: string[];
  /** 用户白名单：填写完整用户邮箱或企微 ID。 */
  userInclude?: string[];
  /** 用户组黑名单：填写组织 group_name。 */
  groupExclude?: string[];
  /** 用户组白名单：填写组织 group_name。 */
  groupInclude?: string[];
}

export interface IntelligenceUserInfo {
  /** 用户完整邮箱，用于匹配包含 @ 的 userInclude/userExclude 配置。 */
  email: string;
  /** 用户企微 ID，用于匹配不包含 @ 的 userInclude/userExclude 配置。 */
  wecomId: string;
  /** 用户所属组织的 group_name，用于匹配 groupInclude/groupExclude。 */
  groups: string[];
}

export const fetchIntelligenceUserInfo = (): Promise<IntelligenceUserInfo> => {
  return fetchIntelligenceUserInfoResponse().then((response) => ({
      email: response?.data?.email || '',
      wecomId: response?.req?.OpenId || '',
      groups:
        response?.data?.groups
          ?.map((group) => group.group_name)
          .filter((value): value is string => !!value) || [],
  }));
};

export const fetchPermissionRules = (): Promise<IntelligencePagePermissionRule[]> => {
  // 权限配置不缓存，保证切换页面时能获取后台最新配置。
  return getQueryDefinition(
    {
      configure_texts: {
        target: 'game_config',
        params: {
          key: 'intelligence_page_permission',
        },
      },
    },
    false,
  ).then((response) => {
    const permissionText = response?.data?.configure_texts?.intelligence_page_permission;
    return permissionText ? JSON.parse(permissionText) : [];
  });
};


